import script from "./LiveSportsFixtureBook.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveSportsFixtureBook.vue?vue&type=script&setup=true&lang=js"

import "./LiveSportsFixtureBook.vue?vue&type=style&index=0&id=2de4e584&scoped=true&lang=css"
import "./LiveSportsFixtureBook.vue?vue&type=style&index=1&id=2de4e584&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2de4e584"]])

export default __exports__